/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import fork from 'fierry/data/fork';

import ZoneControl from 'solis/logic/board/zone/control';
import ZoneUsers from 'solis/logic/board/zone/users';
import ZoneUserControl from 'solis/logic/board/zone/user.control';


export default class TimelineEvent
{
  static create (...args)
  {
    const event = new this(...args);

    event.findNextDate(event.zone.cass.updateDate);

    if (event.date !== null)
    {
      event.apply();
    }

    return event;
  }


  constructor (zone)
  {
    this.date = null;
    this.zone = fork(zone);
  }


  findNextDate (startDate)
  {
  }


  getUserName (user)
  {
    return this.zone.getBoard().getAccountView(user).cass.name;
  }


  setEarlierDate (date)
  {
    if (date !== null && (this.date === null || date < this.date))
    {
      this.date = date;

      return true;
    }

    return false;
  }


  apply ()
  {
    new ZoneControl(this.zone).update(this.date);
  }


  getZone ()
  {
    return this.zone;
  }


  getDate ()
  {
    return this.date;
  }


  equals (other)
  {
    return this.getDate() === other.getDate() && this.getLabel() === other.getLabel();
  }


  getControl (userID, date)
  {
    return new ZoneUserControl(this.zone, userID).getControl(date);
  }


  getInfluence (userID)
  {
    return new ZoneUserControl(this.zone, userID).getInfluence();
  }


  getControlRate (userID, date)
  {
    return new ZoneUserControl(this.zone, userID).getControlRate(date);
  }


  getWinner ()
  {
    return new ZoneUsers(this.zone).getCurrentUser();
  }


  getControlWinner (date)
  {
    return new ZoneControl(this.zone).getControlWinner(date);
  }


  getActiveUsers ()
  {
    return new ZoneUsers(this.zone).getActiveUsers();
  }


  getControlUsers (date)
  {
    return this.getActiveUsers().filter(user => this.getControl(user, date) > 0);
  }


  isContested ()
  {
    return new ZoneUsers(this.zone).isContested();
  }


};
